/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Auth_TitleInputs */



/**
* | output |
* | --- |
* | "Publish Authentication" |
*
* @param {Work_Order_Publish_Auth_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_auth_title = /** @type {((inputs?: Work_Order_Publish_Auth_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Auth_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Authentification de publication")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veröffentlichung der Authentifizierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblica autenticazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Публикация аутентификации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicar autenticación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发布身份验证")
	if (locale === "ja") return /** @type {LocalizedString} */ ("公開認証")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रकाशन प्रमाणीकरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publicar autenticação")
	return /** @type {LocalizedString} */ ("Publish Authentication")
});